module.exports = __webpack_public_path__ + "img/ring_r_l_null_0@3x.b03c19a2.png";